/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const i=["animate","whileInView","whileFocus","whileHover","whileTap","whileDrag","exit"],e=["initial",...i];export{i as variantPriorityOrder,e as variantProps};
//# sourceMappingURL=variant-props.js.map
